
export default {
  props: {
    fixture: {
      type: Object,
      required: true,
    },
  },
  inject: [`refresh`],
  data () {
    return {
      options: {
        series: [],
        xAxis: {
          data: [],
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: `#707070`,
            },
          },
        },
        tooltip: {
          backgroundColor: `#B5050F`,
          borderColor: `#B5050F`,
          trigger: `axis`,
          formatter: params => {
            const minute = params[0].axisValue;
            const prevMinute = minute - 5;
            const minuteString = minute < 5 ? `0'` : `${prevMinute}'-${minute}'`; // eslint-disable-line

            const diff = params[0].data.value;
            const homeTeamPossession = Math.round((50 + (diff / 2)) * 10) / 10;
            const awayTeamPossession = Math.round((50 - (diff / 2)) * 10) / 10;

            return `
              <p class="m-0 c-grey100 tf-bold">${minuteString}</p>
              <h5 class="d-flex justify-sb gap-2 c-primary m-0 c-white">
                <b>${params[0].data.home}</b>
                <span>${homeTeamPossession}%</span>
              </h5>
              <h5 class="d-flex justify-sb gap-2 c-primary m-0 c-white">
                <b>${params[0].data.away}</b>
                <span>${awayTeamPossession}%</span>
              </h5>
            `;
          },
        },
        yAxis: {
          type: `value`,
          min: -100,
          max: 100,
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        visualMap: {
          seriesIndex: 0,
          pieces: [{
            gt: 0,
            color: `#B5050F`,
          },
          {
            value: 0,
            color: `#000000`,
          },
          {
            lt: 0,
            gte: -100, // Required
            color: `#E5832B`,
          }],
          show: false, // Hide label
        },
        grid: {
          top: 20,
          left: 0,
          right: 0,
          bottom: 20,
        },
      },
      possessionIntervals: [],
      refreshInterval: null,
    };
  },
  computed: {
    homeTeam () {
      return this.getTeam(this.fixture);
    },
    awayTeam () {
      return this.getTeam(this.fixture, `Away`);
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.getPossession();

      if (this.refresh) {
        this.refreshInterval = setInterval(() => {
          this.getPossession();
        }, this.refresh);
      }
    });
  },
  beforeDestroy () {
    clearInterval(this.refreshInterval);
  },
  methods: {
    async getPossession () {
      const request = await this.$getCustomStats(`possession/${this.fixture.id}`);
      if (request && request.Home) {
        this.possessionIntervals = request.Home;

        // x is minute; y is possession difference within a 5 minute period
        this.options.xAxis.data = this.possessionIntervals.map(item => item.x);
        this.options.series = [{
          type: `line`,
          data: this.possessionIntervals.map(item => ({
            home: this.homeTeam.team.teamNames[0].displayName,
            away: this.awayTeam.team.teamNames[0].displayName,
            value: parseFloat(item.y.toFixed(1)),
          })),
          smooth: true,
          symbol: `none`,
          silent: true,
        }];
      }
    },
  },
};
